import { render, staticRenderFns } from "./btn-pagination.vue?vue&type=template&id=2b50450c&scoped=true&"
import script from "./btn-pagination.vue?vue&type=script&lang=js&"
export * from "./btn-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50450c",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CButton: require('@chakra-ui/vue').CButton})
